import { V3Record } from 'data/helpers/V3Record.js'

export const RideReport = V3Record('rideReport', {
  title: null, // string
  subtitle: null, // string
  authorByline: null, // string
  authorUrl: null, // string
  slug: null, // string
  titleSlug: null, // string
  featuredImageId: null, // integer
  userId: null, // integer
  reportContent: null, // string
  publishedAt: null // datetime
})

const _defaultDeserialize = RideReport.deserialize
RideReport.deserialize = (fromRails) => {
  const userId = fromRails.user.id
  const rr = _defaultDeserialize(fromRails)
  return rr
    .set('userId', userId)
}
